import RemoveAttachmentModal from './RemoveAttachmentModal'

export default RemoveAttachmentModal
